module.exports = __webpack_public_path__ + "img/L_301_361.190debc5.png";